function getFloatingPosition(dir, position) {
  return position;
}

export { getFloatingPosition };
